// =============================
// common / Bigger Link
// =============================

export function initBiggerLink() {
    // 除外する要素をクリックしたとき
    $(document).on('click', '.s-biggerLink_except', $(this), function(e){
        e.stopPropagation();
    });

    $(document).on('click', '.s-biggerLink_wrap', $(this), function(e){
        e.preventDefault();
        let url = $(this).find('.s-biggerLink').attr('href');
        let targetFocus = function(el) {
            $(el).addClass('is-focus');
            setTimeout(() => {
                $(el).removeClass('is-focus');
            }, 100);
        }

        if (e.ctrlKey || e.metaKey) {
            targetFocus(this);
        } else {
            targetFocus(this);
        }

        window.open(url);
    });
}

